module.exports = __webpack_public_path__ + "img/icon-serve3.2acaf665.png";